export class RealtorsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getRealtors(params) {
    return this.#http.get(`Realtors`, { params, paramsSerializer: { indexes: null } });
  }

  async assignLoanOfficer({ id, assignedLoanOfficerId, connectedLoanOfficerId }) {
    return this.#http.post(`Realtors/${id}`, {
      assignedLoanOfficerId,
      connectedLoanOfficerId,
      needToDeleteAssignedLoanOfficer: !assignedLoanOfficerId,
    });
  }

  async grantRealtorLoanAccess({ applicationId, realtorId }) {
    return this.#http.put(
      `Realtors/loan-applications/${applicationId}/realtors/${realtorId}/access`,
    );
  }

  // advisorPortalConfigurationId is optional (build-ahead — DEV-5167 sibling backend PR): omit
  // or pass null for the legacy no-config invite; the AdminPanel picker (RealtorInviteButton)
  // sends it once the company's AdvisorPortalConfiguration is known/selected.
  async createRealtorInvite({
    firstName,
    lastName,
    email,
    phoneNumber,
    advisorPortalConfigurationId = null,
  }) {
    return this.#http.post(`Realtors/invites`, {
      firstName,
      lastName,
      email,
      phoneNumber,
      advisorPortalConfigurationId,
    });
  }
}
